import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./locales/es.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

// Forzamos español hasta que existan rutas /en y /fr (roadmap i18n ~mayo 2026).
// Mientras tanto, ignoramos navegador/localStorage para evitar incoherencias SEO
// (title en ES + contenido en EN cuando el navegador es inglés).
i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: "es",
  fallbackLng: "es",
  supportedLngs: ["es", "en", "fr"],
  interpolation: { escapeValue: false },
});

export default i18n;
